module.exports = "assets/img/aeroport_liege.jpg";